import $ from 'jquery';
import Component from '../models/Component';

export default class ContactsMap extends Component {
    constructor(element, context) {
        super(element, context);

        $(document).ready(function () {
            let count = 0;

            // Funzione per aggiornare la selezione dei tab
            function updateTabs($container) {
                let $firstH3 = $container.find('h3').first();
                let dataFilter = $firstH3.attr('data-filter');

                // Aggiungi classe 'active' al primo h3
                $firstH3.addClass('active').siblings('.active-icon').show();

                // Nascondi tutti i marker e mostra solo quelli corrispondenti al filtro
                updatePopupMarkers(dataFilter);

                $container.find('h3').click(function () {
                    const dataFilter = $(this).attr('data-filter');

                    // Rimuovi la classe 'active' da tutti gli h3 e aggiungila a quello cliccato
                    $container.find('h3.active').removeClass('active');
                    $(this).addClass('active');

                    // Gestisci le icone e il conteggio dei marker visibili
                    $container.find('.active-icon').hide();
                    $(this).siblings('.active-icon').show();

                    // Aggiorna i marker visibili
                    updatePopupMarkers(dataFilter);

                    // Ricalcola il conteggio dei marker visibili
                    countVisibleMarkers();
                });
            }

            // Funzione per aggiornare i marker visibili
            function updatePopupMarkers(filter) {
                $('.popup-marker').hide();
                $('.popup-marker[data-area="' + filter + '"]').fadeIn();
            }

            // Funzione per conteggiare i marker visibili
            function countVisibleMarkers() {
                count = 0;
                document.querySelectorAll('.popup-marker').forEach((element) => {
                    if (getComputedStyle(element).display === 'block') count++;
                });
            }

            // Desktop
            if ($('.tabs-countries .desktop-tabs').is(':visible')) {
                updateTabs($('.tabs-countries .desktop-tabs'));
            }

            // Mobile
            if ($('.mobile-list').is(':visible')) {
                updateTabs($('.mobile-list'));
            }

            // Conteggio iniziale dei marker visibili
            countVisibleMarkers();

            // Codice per il dropdown e la gestione del menu
            const dropdown = document.querySelector('.h3-dropdown');
            const trigger = dropdown.querySelector('.dropdown-trigger');
            const menu = dropdown.querySelector('.dropdown-menu');
            const activeItem = trigger.querySelector('.active-item span'); // Seleziona solo lo span che contiene il testo

            // Mostra o nasconde il menu quando il trigger è cliccato
            trigger.addEventListener('click', () => {
                const isMenuVisible = menu.classList.contains('show');
                if (isMenuVisible) {
                    menu.classList.remove('show');
                    dropdown.classList.remove('active');
                } else {
                    menu.classList.add('show');
                    dropdown.classList.add('active');
                }
            });

            // Cambia solo il testo dell'elemento attivo quando si clicca su un'opzione nel menu
            menu.addEventListener('click', (event) => {
                const clickedItem = event.target.closest('h3'); // Assicurati che l'elemento cliccato sia un h3
                if (!clickedItem) return;

                // Modifica solo il testo del nome, mantenendo intatta la struttura e le icone
                activeItem.textContent = clickedItem.textContent.trim();

                // Chiudi il menu e rimuovi la classe active
                menu.classList.remove('show');
                dropdown.classList.remove('active');
            });

            // Chiude il menu se clicchi fuori dal dropdown
            document.addEventListener('click', (event) => {
                if (!dropdown.contains(event.target) && menu.classList.contains('show')) {
                    menu.classList.remove('show');
                    dropdown.classList.remove('active');
                }
            });
        });
    }
}
